export const delimiter = '\uFE3B'
